/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { history } from '@services/History'
import { clearStore } from '@/index.Dux'
import Consultations from '@services/Consultations'
import { updateServices, clearServices } from '../../utilities/actions'
import { getSelf } from './auth.Dux'

const SignOut = () => {
  const self = useSelector((state) => getSelf(state))
  const dispatch = useDispatch()
  const signOut = async () => {
    //need update headers, if not dont have jwt nad cant logout
    updateServices(self.jwtToken)
    try {
      await Consultations.auth.logout()
      dispatch(clearStore())
      //clear services
      clearServices()
      history.push('/')
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    signOut()
  }, [])

  return null
}
export default SignOut
